'use strict';

// Constants
var caseVideo = require( './components/video' ).default,
    home = require( './components/home' ).default,
    brief = require( './components/brief' ).default;


var oneTable = (function() {

    var _self = {
        init: function() {
            document.querySelector('body').classList.add('loaded');
            //console.log('inited');
            oneTable.addIEClass();
            oneTable.initMenu();

            if (document.body.classList.contains('home')) {
                home.init();
            }
            if (document.body.classList.contains('inspiration') || document.body.classList.contains('inspiration-1')) {
                caseVideo.init();
            }
            if (document.body.classList.contains('brief')) {
                brief.init();
            }
        },
        addIEClass: function() {
            if (window.isIE) {
                document.querySelector('html').classList.add('ie-11');
            }
        },
        initMenu: function() {
            
            var body = document.querySelector('body'),
                header = body.querySelector('.header'),
                toggle = header.querySelector('.menu-trigger');

            toggle.addEventListener('click', function(event){
                if (header.classList.contains('open')) {
                    header.classList.remove('open');
                    body.classList.remove('no-scroll');
                } else {
                    header.classList.add('open');
                    body.classList.add('no-scroll');
                }
                event.preventDefault();
            }, false);
        }
    };

    return _self;
})();


(function(window, body, undefined) { // document ready...
    oneTable.init();
})(window, document.body);



// WEBPACK FOOTER //
// ./src/js/main.js